module.exports = __webpack_public_path__ + "assets/img/logoPraqtLogin.d4fed349.png";